import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <div className='footer__inner'>
      <p className='footer__text'>
        &copy; 2026 Praneeth M &mdash; Built with{' '}
        <span className='footer__heart'>&hearts;</span> and React
      </p>
    </div>
  </footer>
)

export default Footer
